
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.699 3.596l2.706 2.706a.638.638 0 010 .902l-.902.902-3.609-3.609.902-.901a.638.638 0 01.903 0zm.902 5.412L10.993 5.4l-7.06 7.06a.639.639 0 00-.182.38l-.339 3.044a.638.638 0 00.705.705l3.044-.339a.637.637 0 00.381-.183z","fill-rule":"evenodd"}})])
          )
        }
      }
    